import '@shared/js/polyfills';
import Vue from 'vue';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import './bootstrap';
import 'moment/dist/locale/de';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/it';
import 'moment/dist/locale/es';
import 'moment/dist/locale/ca';
import Helpers from '@legacy/js/helpers';
import { init as initOne } from '@js/one/app';
import { init as initViewMode } from '@js/view-mode/app';
import { init as initFullPageMode } from '@js/full-page-mode/app';
import { init as initMoments } from '@js/moments/app';
import $I18n from '@js/i18n';
import { initEmbedViewMode } from '@js/embed-setup';
import { setupToast } from '@shared/plugins/Toast';
import { getArenaConfig } from '@shared/utils/getArenaConfig';
import { installTranslationUpdater } from '@shared/js/i18n/translationUpdater';
import dev from '@js/dev';
import Analytics from '@shared/js/analytics';
import '@legacy/js/bootstrap';
import Icon from '@components/Icon';
import LabelWithTooltip from '@components/LabelWithTooltip';
import ViewMultiFormat from '@shared/Views/ViewMultiFormat';

momentDurationFormatSetup(moment);
moment.locale(window.locale);

window.Helpers = new Helpers();
window.moment = moment;
Vue.prototype.$I18n = $I18n;
window.$I18n = $I18n;
Vue.prototype.$Helpers = new Helpers();
window.$Helpers = new Helpers();
Vue.prototype.$Analytics = new Analytics();
window.$Analytics = new Analytics();
Vue.prototype.$arenaConfig = getArenaConfig();
window.$arenaConfig = getArenaConfig();
window.openModals = [];

// Enable live translation updates
installTranslationUpdater(Vue);

Vue.component('Icon', Icon);
Vue.component('LabelWithTooltip', LabelWithTooltip);
Vue.component('ViewMultiFormat', ViewMultiFormat);

dev.setup();
setupToast();

const formatSize = (size) => {
	if (size > 1024 * 1024 * 1024 * 1024) {
		return `${(size / 1024 / 1024 / 1024 / 1024).toFixed(2)} TB`;
	} else if (size > 1024 * 1024 * 1024) {
		return `${(size / 1024 / 1024 / 1024).toFixed(2)} GB`;
	} else if (size > 1024 * 1024) {
		return `${(size / 1024 / 1024).toFixed(0)} MB`;
	} else if (size > 1024) {
		return `${(size / 1024).toFixed(0)} KB`;
	}
	return `${size.toString()} B`;
};

let appWasSuccessfullyInitialized = false;
const initApp = () => {
	if (document.querySelector('#one')) {
		Vue.filter('formatSize', formatSize);
		initOne();
		appWasSuccessfullyInitialized = true;
	} else if (document.querySelector('#embed-view-mode')) {
		initEmbedViewMode(initViewMode);
		appWasSuccessfullyInitialized = true;
	} else if (document.querySelector('#full-page-mode')) {
		Vue.filter('formatSize', formatSize);
		initFullPageMode();
		appWasSuccessfullyInitialized = true;
	} else if (document.querySelector('#moments')) {
		initMoments({
			event: window.multiFormatEvent?.event,
		});
		appWasSuccessfullyInitialized = true;
	}
};

initApp();

// periodically check if the app was successfully initialized, otherwise try again
// Upcoming Events on TV are mounted inside the Arena Vue Instance, which might not be ready yet
const interval = setInterval(() => {
	if (appWasSuccessfullyInitialized) {
		clearInterval(interval);
	} else {
		initApp();
	}
}, 500);

window.createAsportPlayer = initViewMode;
